module.exports = __webpack_public_path__ + "img/workFlowVideo.6de7709b.png";